import { Row, Col, Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const TraineeshipChangesTable = ({ data, size }) => {
    const { t } = useTranslation('translation', { keyPrefix: 'traineeships.singleView.changes'});

    // Function to format date from YYYY-MM-DD to DD-MM-YYYY
    const formatDate = (dateString) => {
      if (!dateString) return '';
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString; // Return original if invalid
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    };

    // Helper function to check if a value exists
    const hasValue = (value) => {
      return value !== null && value !== undefined && value !== '';
    };

    // Check if all fields in final_table_a2 are null
    const allFieldsNull = !data || (
        !hasValue(data?.field_tr_final_tbl_a2_title) &&
        !hasValue(data?.field_tr_final_tbl_a2_sta_period) &&
        !hasValue(data?.field_tr_final_tbl_a2_end_period) &&
        !hasValue(data?.field_tr_final_tbl_a2_sta_per_v) &&
        !hasValue(data?.field_tr_final_tbl_a2_end_per_v) &&
        !hasValue(data?.field_tr_final_tbl_a2_whs) &&
        !hasValue(data?.field_tr_final_tbl_a2_program) &&
        !hasValue(data?.field_tr_final_tbl_a2_knowledge) &&
        !hasValue(data?.field_tr_final_tbl_a2_monitor) &&
        !hasValue(data?.field_tr_final_tbl_a2_evaluation)
    );

    if (allFieldsNull) {
        return (
            <Container>
                <Row style={{ paddingLeft: 10, paddingBottom: 15 }}>
                    <Col>
                        <Row style={{ paddingTop: 10, paddingBottom: 10 }}>
                            <Col className='text-center'>{t('noChangesAvailable')}</Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        );
    }

    return (
        <Container>
            <Row style={{ paddingLeft: 10, paddingBottom: 15 }}>
                <Col>
                    {hasValue(data?.field_tr_final_tbl_a2_title) && (
                        <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                            <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                {t('title')}
                            </Col>
                            <Col>{data?.field_tr_final_tbl_a2_title}</Col>
                        </Row>
                    )}
                    {hasValue(data?.field_tr_final_tbl_a2_sta_period) && (
                        <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                            <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                {t('startDate')}
                            </Col>
                            <Col>{formatDate(data?.field_tr_final_tbl_a2_sta_period)}</Col>
                        </Row>
                    )}
                    {hasValue(data?.field_tr_final_tbl_a2_end_period) && (
                        <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                            <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                {t('endDate')}
                            </Col>
                            <Col>{formatDate(data?.field_tr_final_tbl_a2_end_period)}</Col>
                        </Row>
                    )}
                    {hasValue(data?.field_tr_final_tbl_a2_sta_per_v) && (
                        <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                            <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                {t('startDateVirtual')}
                            </Col>
                            <Col>{formatDate(data?.field_tr_final_tbl_a2_sta_per_v)}</Col>
                        </Row>
                    )}
                    {hasValue(data?.field_tr_final_tbl_a2_end_per_v) && (
                        <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                            <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                {t('endDateVirtual')}
                            </Col>
                            <Col>{formatDate(data?.field_tr_final_tbl_a2_end_per_v)}</Col>
                        </Row>
                    )}
                    {hasValue(data?.field_tr_final_tbl_a2_whs) && (
                        <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                            <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                {t('workingHoursPerWeek')}
                            </Col>
                            <Col>{data?.field_tr_final_tbl_a2_whs}</Col>
                        </Row>
                    )}
                    {hasValue(data?.field_tr_final_tbl_a2_program) && (
                        <>
                            <Row style={{ paddingTop: 20, paddingBottom: 10 }}>
                                <Col>
                                    <hr style={{ margin: 0, borderTop: '2px solid #dee2e6' }} />
                                </Col>
                            </Row>
                            <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                    {t('detailedProgramme')}
                                    {data?.field_tr_final_tbl_a2_sta_per_v && (
                                        <div style={{ fontWeight: 'normal' }}>({t('includingTheVirtualComponent')})</div>
                                    )}
                                </Col>
                                <Col style={{ whiteSpace: 'pre-wrap' }}>{data?.field_tr_final_tbl_a2_program}</Col>
                            </Row>
                        </>
                    )}
                    {hasValue(data?.field_tr_final_tbl_a2_knowledge) && (
                        <>
                            <Row style={{ paddingTop: 20, paddingBottom: 10 }}>
                                <Col>
                                    <hr style={{ margin: 0, borderTop: '2px solid #dee2e6' }} />
                                </Col>
                            </Row>
                            <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                    {t('knowledgeSkillsCompetences')}
                                </Col>
                                <Col>{data?.field_tr_final_tbl_a2_knowledge}</Col>
                            </Row>
                        </>
                    )}
                    {hasValue(data?.field_tr_final_tbl_a2_monitor) && (
                        <>
                            <Row style={{ paddingTop: 20, paddingBottom: 10 }}>
                                <Col>
                                    <hr style={{ margin: 0, borderTop: '2px solid #dee2e6' }} />
                                </Col>
                            </Row>
                            <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                    {t('monitoringPlan')}
                                </Col>
                                <Col>{data?.field_tr_final_tbl_a2_monitor}</Col>
                            </Row>
                        </>
                    )}
                    {hasValue(data?.field_tr_final_tbl_a2_evaluation) && (
                        <>
                            <Row style={{ paddingTop: 20, paddingBottom: 10 }}>
                                <Col>
                                    <hr style={{ margin: 0, borderTop: '2px solid #dee2e6' }} />
                                </Col>
                            </Row>
                            <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                    {t('evaluationPlan')}
                                </Col>
                                <Col>{data?.field_tr_final_tbl_a2_evaluation}</Col>
                            </Row>
                        </>
                    )}
                </Col>
            </Row>
        </Container>
    );
}

export default TraineeshipChangesTable;